import axios from 'axios'
export default {
  getArticles: (id, config = {}) => axios.get(`/article/${id}`, config)
}



// WEBPACK FOOTER //
// ./src/networks/api/Article/index.js